const RAPIDAPI_KEY = '9ec3632ffcmsh57345cb6b7b4d10p1441a8jsn08ebbdefa195';
const RAPIDAPI_HOST = 'deezerdevs-deezer.p.rapidapi.com';

class DeezerAPI {
  async searchTracks(query, limit = 100) {
    try {
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/search?q=${encodeURIComponent(query)}&limit=${limit}`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      return {
        data: data.data,
        total: data.total || data.data.length
      };
      
    } catch (error) {
      console.error('Error buscando canciones:', error);
      return null;
    }
  }

  async searchArtists(query, limit = 150) {
    try {
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/search/artist?q=${encodeURIComponent(query)}&limit=${limit}`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );
      
      const data = await response.json();
      return {
        data: data.data,
        total: data.total || data.data.length
      };
      
    } catch (error) {
      console.error('Error buscando artistas:', error);
      return null;
    }
  }

  async searchAlbums(query, limit = 150) {
    try {
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/search/album?q=${encodeURIComponent(query)}&limit=${limit}`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );

      const data = await response.json();
      return {
        data: data.data,
        total: data.total || data.data.length
      };

    } catch (error) {
      console.error('Error buscando álbumes:', error);
      return null;
    }
  }

  async getTrackById(trackId) {
    try {
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/track/${trackId}`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('Error obteniendo track:', error);
      return null;
    }
  }
}

const deezerAPI = new DeezerAPI();
export default deezerAPI;